import { AnnouncementDefinition } from '@/contexts/announcements/model/Announcements.model.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';

export const AnnouncementAnchorKey = {
  CONTACTS_MENU_ITEM: 'contacts-menu-item',
  CUSTOMERS_INDIVIDUAL_DISTINGUISHING_LABEL: 'customers-individual-distinguishing-label',
  DASHBOARD_PROCESSES: 'dashboard-processes',
  DASHBOARD_QUICK_ACTIONS: 'dashboard-quick-actions',
  DASHBOARD_TASKS: 'dashboard-tasks',
  EMAILS_COPY_RECIPIENTS: 'emails-copy-recipients',
  EMAILS_PROCESS_MATCH: 'emails-process-match',
  TASKS_FULL_TEXT_SEARCH: 'tasks-full-text-search',
  TASKS_MENU_ITEM: 'tasks-menu-item',
  TOP_BAR_ANNOUNCEMENTS: 'top-bar-announcements',
  TOP_BAR_FEEDBACK: 'top-bar-feedback',
} as const;

export const emailAnnouncementAnchorKeys = new Set<string>([
  AnnouncementAnchorKey.EMAILS_COPY_RECIPIENTS,
  AnnouncementAnchorKey.EMAILS_PROCESS_MATCH,
]);

const PRIMARY_ANNOUNCEMENT_ROUTES: RouteEnum[] = [
  RouteEnum.ROOT,
  RouteEnum.DASHBOARD,
  RouteEnum.EMAILS,
  RouteEnum.CHATS,
  RouteEnum.TASKS,
  RouteEnum.PROCESSES,
  RouteEnum.CONTACTS,
  RouteEnum.CUSTOMERS,
  RouteEnum.SUPPLIERS,
  RouteEnum.CARS,
  RouteEnum.DICTIONARIES,
  RouteEnum.COMPONENT_DEFINITIONS,
  RouteEnum.OFFER_DEFINITIONS,
  RouteEnum.USERS,
  RouteEnum.EMERGENCY_CONTACTS,
];

export const announcementDefinitions: AnnouncementDefinition[] = [
  {
    anchorKey: AnnouncementAnchorKey.TOP_BAR_ANNOUNCEMENTS,
    announcementId: 'topbar.announcements.v1',
    order: 10,
    route: PRIMARY_ANNOUNCEMENT_ROUTES,
    translationKey: 'items.topBarAnnouncements',
  },
  {
    anchorKey: AnnouncementAnchorKey.TOP_BAR_FEEDBACK,
    announcementId: 'topbar.feedback.v1',
    order: 20,
    route: PRIMARY_ANNOUNCEMENT_ROUTES,
    translationKey: 'items.topBarFeedback',
  },
  {
    anchorKey: AnnouncementAnchorKey.CONTACTS_MENU_ITEM,
    announcementId: 'contacts.menuItem.inactiveConflictFix.v1',
    order: 22,
    route: PRIMARY_ANNOUNCEMENT_ROUTES,
    translationKey: 'items.contactsMenuItemInactiveConflictFix',
  },
  {
    anchorKey: AnnouncementAnchorKey.CUSTOMERS_INDIVIDUAL_DISTINGUISHING_LABEL,
    announcementId: 'customers.individual.distinguishingLabel.v1',
    order: 25,
    route: PRIMARY_ANNOUNCEMENT_ROUTES,
    translationKey: 'items.customersIndividualDistinguishingLabel',
  },
  {
    anchorKey: AnnouncementAnchorKey.TASKS_MENU_ITEM,
    announcementId: 'tasks.menuItem.watchersAccess.v1',
    order: 27,
    route: PRIMARY_ANNOUNCEMENT_ROUTES,
    translationKey: 'items.tasksMenuItemWatchersAccess',
  },
  {
    anchorKey: AnnouncementAnchorKey.DASHBOARD_QUICK_ACTIONS,
    announcementId: 'dashboard.quick-actions.v1',
    order: 30,
    route: [RouteEnum.ROOT, RouteEnum.DASHBOARD],
    translationKey: 'items.dashboardQuickActions',
  },
  {
    anchorKey: AnnouncementAnchorKey.DASHBOARD_PROCESSES,
    announcementId: 'dashboard.processes.v1',
    order: 40,
    route: [RouteEnum.ROOT, RouteEnum.DASHBOARD],
    translationKey: 'items.dashboardProcesses',
  },
  {
    anchorKey: AnnouncementAnchorKey.DASHBOARD_TASKS,
    announcementId: 'dashboard.tasks.v1',
    order: 50,
    requiresRole: true,
    route: [RouteEnum.ROOT, RouteEnum.DASHBOARD],
    translationKey: 'items.dashboardTasks',
  },
  {
    anchorKey: AnnouncementAnchorKey.TASKS_FULL_TEXT_SEARCH,
    announcementId: 'tasksList.fullTextSearch.v1',
    order: 60,
    requiresRole: true,
    route: [RouteEnum.TASKS],
    translationKey: 'items.tasksFullTextSearch',
  },
  {
    anchorKey: AnnouncementAnchorKey.EMAILS_PROCESS_MATCH,
    announcementId: 'emails.processMatch.v1',
    order: 70,
    route: [RouteEnum.EMAILS],
    translationKey: 'items.emailsProcessMatch',
  },
  {
    anchorKey: AnnouncementAnchorKey.EMAILS_COPY_RECIPIENTS,
    announcementId: 'emails.copyRecipients.v1',
    order: 80,
    route: [RouteEnum.EMAILS],
    translationKey: 'items.emailsCopyRecipients',
  },
];
